<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalFactura }}</h2>
              <p>Facturas Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalBoleta }}</h2>
              <p>Boletas Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-warning">
         <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalGuias }}</h2>
              <p>Gu&iacute;as Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalNotacredito }}</h2>
              <p>Notas de Cr&eacute;dito Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalComunicacionBaja }}</h2>
              <p>Com. de baja Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="2">
        <b-card no-body class="bg-dark">
          <b-card-body class="pb-0">
            <template v-if="loading">
              <div class="text-center">
                <h2><i class="fa fa-spinner fa-pulse"/> Cargando</h2>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-0 display-5">{{ totalNotaDebito }}</h2>
              <p>Notas de Débito Emitidas</p>
              <!-- <p>En mantenimiento</p> -->
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
        <b-card bg-variant="light" header="Noticias" class="text-center">
            <template>
              <div>
                <b-carousel
                  id="carousel-1"
                  v-model="slide"
                  :interval="30000"
                  controls
                  indicators
                  background="#ababab"
                  img-width="960"
                  img-height="468"
                  style="text-shadow: 1px 1px 2px #333;"
                  @sliding-start="onSlideStart"
                  @sliding-end="onSlideEnd"
                >
                  
                  <b-carousel-slide 
                    background="#006eae"
                    style="width: 750px; margin-left: 1.5%;"
                    caption="IMPUESTO A LAS BOLSAS DE PLASTICO" 
                    img-blank img-alt="Blank image">
                    <h6>(Nº 150-2019/SUNAT)</h6>
                    <p>
                      El Impuesto a las Bolsas Plásticas -- debe ser añadido a la compra como un ITEM más con el precio de S/ 0.10 por cada bolsa y el Tipo de Afectación Inafecto.
                      Sugerimos, agregar en la Lista de Productos un nuevo producto con las sgtes. características:
                    </p><br>
                    <template>
                      <div>
                        <b-table style="padding: 0; margin: 0;" class="text-white" :small="small" hover
                                 :items="items"/>
                      </div>
                    </template>
                  </b-carousel-slide>
                  <b-carousel-slide
                          style="width: 750px; margin-left: 1.5%;"
                          img-src="http://telemovildata.com/publicidad/slider1.jpeg"
                  />
                  <b-carousel-slide
                          style="width: 750px; margin-left: 1.5%;"
                          img-src="http://telemovildata.com/publicidad/slider2.jpeg"
                  />
                </b-carousel>
              </div>
            </template>
        </b-card>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col cols="6">
        <b-card header="ACUMULADO DE VENTAS SOLES">
          <template>
            <div>
              <b-table-simple hover bordered response fixed>
                <b-thead>
                  <b-tr >
                    <b-th></b-th>
                    <b-th class="cabecera">FACTURA </b-th>
                    <b-th class="cabecera">BOLETA</b-th>
                    <b-th class="cabecera">TOTALES</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <template v-if="informeAcumulado">
                  <b-tr>
                    <b-td>DIA</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facSolesDia >'0'">S/. {{ (informeAcumulado.facSolesDia).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolSolesDia >'0'">S/. {{ (informeAcumulado.bolSolesDia).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facSolesDia >'0' && informeAcumulado.bolSolesDia >'0'">S/. {{ ((informeAcumulado.facSolesDia) + (informeAcumulado.bolSolesDia)).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>SEMANA</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facSolesSemana >'0'">S/. {{ (informeAcumulado.facSolesSemana).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolSolesSemana >'0'">S/. {{ (informeAcumulado.bolSolesSemana).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facSolesSemana >'0' && informeAcumulado.bolSolesSemana >'0'">S/. {{ ((informeAcumulado.facSolesSemana) + (informeAcumulado.bolSolesSemana)).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>MES</b-td>  
                    <b-td class="text-right" v-if="informeAcumulado.facSolesMes >'0'">S/. {{ (informeAcumulado.facSolesMes).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolSolesMes >'0'">S/. {{ (informeAcumulado.bolSolesMes).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facSolesMes >'0' && informeAcumulado.bolSolesMes >'0'">S/. {{ ((informeAcumulado.facSolesMes) + (informeAcumulado.bolSolesMes)).toFixed(2) }}</b-td><b-td v-else class="text-right">S/. 0.00</b-td>            
                  </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
            </div>
          </template>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header="ACUMULADO DE VENTAS DOLARES">
          <template>
            <div>
              <b-table-simple hover bordered response fixed>
                <b-thead>
                  <b-tr >
                    <b-th></b-th>
                    <b-th class="cabecera">FACTURA </b-th>
                    <b-th class="cabecera">BOLETA</b-th>
                    <b-th class="cabecera">TOTALES</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>DIA</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresDia >'0'">$ {{ (informeAcumulado.facDolaresDia).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolDolaresDia >'0'">$ {{ (informeAcumulado.bolDolaresDia).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresDia >'0' && informeAcumulado.facDolaresDia >'0'">$ {{ ((informeAcumulado.facDolaresDia) + (informeAcumulado.bolDolaresDia)).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>SEMANA</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresSemana >'0'">$ {{ (informeAcumulado.facDolaresSemana).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolDolaresSemana >'0'">$ {{ (informeAcumulado.bolDolaresSemana).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresSemana >'0' && informeAcumulado.facDolaresSemana >'0'">$ {{ ((informeAcumulado.facDolaresSemana) + (informeAcumulado.bolDolaresSemana)).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>MES</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresMes >'0'">$ {{ (informeAcumulado.facDolaresMes).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.bolDolaresMes >'0'">$ {{ (informeAcumulado.bolDolaresMes).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                    <b-td class="text-right" v-if="informeAcumulado.facDolaresMes >'0' && informeAcumulado.facDolaresMes >'0'">$ {{ ((informeAcumulado.facDolaresMes) + (informeAcumulado.bolDolaresMes)).toFixed(2) }}</b-td><b-td v-else class="text-right">$ 0.00</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card header="PRODUCTOS MAS VENDIDO">
          <b-row>
            <b-col cols="4">
              <div class="colorTituloProductos"><b>DIA</b></div>
              <template>
                <div>
                  <b-table 
                  responsive
                  outlined
                  fixed
                  bordered
                  :items="informeAcumuladoItemDia"
                  :fields="informeAcumuladoItem_Dia"
                  >
                  <template slot="productoDia" slot-scope="row">
                    <div> 
                      {{row.item.descripcion.toUpperCase()}}
                    </div>
                  </template>
                  <template slot="cantidad" slot-scope="row">
                    <div class="text-center">
                      {{row.item.cantidad}}
                    </div>
                  </template>
                  <template slot="total" slot-scope="row">
                    <div class="text-center">
                      {{row.item.total}}
                    </div>
                  </template>
                  </b-table>
                </div>
                <b-row>
                  <b-col cols="9">
                    <p>Mostrando del {{desdeDia}} al {{hastaDia}} de un total de {{totalDia}} registros</p>
                  </b-col>
                  <b-col>
                    <b-pagination
                      size="sm"
                      :total-rows="totalDia"
                      v-model="paginaActualDia"
                      @input="reporteTotalesItemDia"
                      :per-page="limiteMostradoItemsDia">
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
            </b-col>
            <b-col cols="4">
              <div class="colorTituloProductos"><b>SEMANA</b></div>
              <template>
                <div>
                  <b-table 
                  responsive
                  outlined
                  fixed
                  bordered
                  :items="informeAcumuladoItemSemana"
                  :fields="informeAcumuladoItem_Semana"
                  >
                  <template slot="productoSemana" slot-scope="row">
                    <div>
                      {{row.item.descripcion.toUpperCase()}}
                    </div>
                  </template>
                  <template slot="cantidad" slot-scope="row">
                    <div class="text-center">
                      {{row.item.cantidad}}
                    </div>
                  </template>
                  <template slot="total" slot-scope="row">
                    <div class="text-center">
                      {{row.item.total}}
                    </div>
                  </template>
                  </b-table>
                </div>
                <b-row>
                  <b-col cols="9">
                    <p>Mostrando del {{desdeSemana}} al {{hastaSemana}} de un total de {{totalSemana}} registros</p>
                  </b-col>
                  <b-col>
                    <b-pagination
                      size="sm"
                      :total-rows="totalSemana"
                      v-model="paginaActualSemana"
                      @input="reporteTotalesItemSemana"
                      :per-page="limiteMostradoItemsSemana">
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
            </b-col>
            <b-col cols="4">
              <div class="colorTituloProductos"><b>MES</b></div>
              <template>
                <div>
                  <b-table 
                  responsive
                  outlined
                  fixed
                  bordered
                  :items="informeAcumuladoItemMes"
                  :fields="informeAcumuladoItem_Mes"
                  >
                  <template slot="productoMes" slot-scope="row">
                    <div>
                      {{row.item.descripcion.toUpperCase()}}
                    </div>
                  </template>
                  <template slot="cantidad" slot-scope="row">
                    <div class="text-center">
                      {{row.item.cantidad}}
                    </div>
                  </template>
                  <template slot="total" slot-scope="row">
                    <div class="text-center">
                      {{row.item.total}}
                    </div>
                  </template>
                  </b-table>
                </div>
                <b-row>
                <b-col cols="9">
                  <p>Mostrando del {{desdeMes}} al {{hastaMes}} de un total de {{totalMes}} registros</p>
                </b-col>
                <b-col>
                  <b-pagination
                    size="sm"
                    :total-rows="totalMes"
                    v-model="paginaActualMes"
                    @input="reporteTotalesItemMes"
                    :per-page="limiteMostradoItemsMes">
                  </b-pagination>
                </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'dashboard',
  data: function () {
    return {
      dataplace: 'jelou',
      datatext: '',
      small: true,
      slide: 0,
      sliding: null,
      loading: false,
      totalFactura: 0,
      totalBoleta: 0,
      totalNotacredito: 0,
      totalGuias: 0,
      totalComunicacionBaja: 0,
      totalNotaDebito: 0,
      items: [
          { codigo: 'ICBPER', unidad_medida: 'UNIDAD', descripcion: 'Impuesto a las bolsas plasticas ICBPER', precio: '0.10', tipoAfectacion: 'Inafecto' },
      ],
      datospanelemail:{},
      informeAcumulado:{},
      informeAcumuladoItemDia:[],
      informeAcumuladoItemSemana:[],
      informeAcumuladoItemMes:[],
      informeAcumuladoItem_Dia:[
        { key: 'productoDia', label:'PRODUCTO',sorteable: true},
        { key: 'cantidad', label:'CANTIDAD',sorteable: true},
        { key: 'total', label:'TOTAL',sorteable: true},
      ],
      informeAcumuladoItem_Semana:[
        { key: 'productoSemana', label:'PRODUCTO',sorteable: true},
        { key: 'cantidad', label:'CANTIDAD',sorteable: true},
        { key: 'total', label:'TOTAL',sorteable: true},
      ],
      informeAcumuladoItem_Mes:[
        { key: 'productoMes', label:'PRODUCTO',sorteable: true},
        { key: 'cantidad', label:'CANTIDAD',sorteable: true},
        { key: 'total', label:'TOTAL',sorteable: true},
      ],
      totalDia:0.0,
      desdeDia:0.0,
      hastaDia:0.0,
      limiteMostradoItemsDia:15,
      paginaActualDia:1,
      totalSemana:0.0,
      desdeSemana:0.0,
      hastaSemana:0.0,
      limiteMostradoItemsSemana:15,
      paginaActualSemana:1,
      totalMes:0.0,
      desdeMes:0.0,
      hastaMes:0.0,
      limiteMostradoItemsMes:15,
      paginaActualMes:1,
      descendente:'desc'
    }
  },
  mounted () {
    this.totalDocs()
    this.mensaje()
    this.reporteTotales()
    this.reporteTotalesItemDia();
    this.reporteTotalesItemSemana();
    this.reporteTotalesItemMes();
    // this.validaCorreo()
  },
  methods: {
    totalDocs: function () {
      this.loading = true;
       axios
       .post(process.env.VUE_APP_API_URL + 'documento/resumen',{
          token: this.$store.getters.userToken
       })
       .then(response => {
          this.totalFactura = response.data.msg.f;
          this.totalBoleta = response.data.msg.b;
          this.totalNotacredito = response.data.msg.cn;
          this.totalGuias = response.data.msg.gr;
          this.totalComunicacionBaja = response.data.msg.cb;
          this.totalNotaDebito = response.data.msg.nd;
          this.loading = false;
        })
       .catch(error => {
          this.loading = false;
          console.log("Error: documento/resumen" + error)
       })
    },
    mensaje: function () {
      let popup = "";
      let mensaje  = "";
      this.$store.getters.userMensajes.forEach(function(element){
         if(element.popup == '1'){
            popup = element.popup
            mensaje = element.mensaje
         }
      })
        // mensaje = "Estimado cliente, Su servicio será suspendido en las próximas horas por mantener facturas impagadas. CONSULTE LAS FORMAS DE PAGO EN"
        // let telefono = "Teléfonos: 995570648"
      if(popup == '1'){
          Swal.fire({
          title: 'Atención!!!',
          // html: mensaje + ' <a class="openUrl" href="http://telemovildata.com/formadepago">Formas de Pago</a> ' + telefono,
          html:mensaje,
          icon: 'warning',
        })
      };
    },
    validaCorreo(){
      let validamsg = {}
      axios
      .post(process.env.VUE_APP_API_URL + 'usuario/validar/email',{
        token: this.$store.getters.userToken
      })
      .then(response=>{
        validamsg = response.data
        this.alerta(validamsg)
      })
      .catch(error =>(
        console.log(error)
      ))
    },
    alerta(valor){
      if(valor.success !=1){    
          this.datospanelemail = {
          visible: true,
          modaluseredit: true
        }
        this.$store.commit('setemailpanel', this.datospanelemail)
      }     
      if(valor.success != 1){
        Swal.fire({
          title: 'Importante!!',
          text: valor.msg,
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#22bb33',
          cancelButtonColor: '',
          confirmButtonText: 'Registrar',
          cancelButtonText: 'Quizás luego',
        }).then((result) => {
          if (result.isConfirmed) {
             this.datospanelemail = {
                visible: true,
                modaluseredit: true
              }
              this.$store.commit('setemailpanel', this.datospanelemail)       
              this.$router.push('/panel').catch(err => {})
          }else{
            let vacio2 = []
            this.$store.commit('setemailpanel', vacio2)
          }
        })
        .catch((error=>{
          let vacio = []
          this.$store.commit('setemailpanel', vacio)
        }))
      }
    },
    reporteTotales(){
      axios
      .post(process.env.VUE_APP_API_URL + 'reporte/totales',{
        token: this.$store.getters.userToken
      })
      .then(response=>(
        this.informeAcumulado = response.data.response
      ))
      .catch(error=>(
        console.log('ERROR',error)
      ))
    },
    reporteTotalesItemDia(){
      axios
      .post(process.env.VUE_APP_API_URL + 'reporte/totales/items',{
        token: this.$store.getters.userToken,
        order: this.descendente,
        limit: this.limiteMostradoItemsDia,
        page:  this.paginaActualDia,
      })
      .then(response=>(
        this.informeAcumuladoItemDia = response.data.response.listaitemsDia.data,
        this.desdeDia = response.data.response.listaitemsDia.from,
        this.hastaDia = response.data.response.listaitemsDia.to,
        this.totalDia = response.data.response.listaitemsDia.total
      ))
      .catch(error=>(
        console.log('ERROR',error)
      ))
    },
    reporteTotalesItemSemana(){
      axios
      .post(process.env.VUE_APP_API_URL + 'reporte/totales/items',{
        token: this.$store.getters.userToken,
        order: this.descendente,
        limit: this.limiteMostradoItemsSemana,
        page:  this.paginaActualSemana,
      })
      .then(response=>(
        this.informeAcumuladoItemSemana = response.data.response.listaitemsSemana.data,
        this.desdeSemana = response.data.response.listaitemsSemana.from,
        this.hastaSemana = response.data.response.listaitemsSemana.to,
        this.totalSemana = response.data.response.listaitemsSemana.total
      ))
      .catch(error=>(
        console.log('ERROR',error)
      ))
    },
    reporteTotalesItemMes(){
      axios
      .post(process.env.VUE_APP_API_URL + 'reporte/totales/items',{
        token: this.$store.getters.userToken,
        order: this.descendente,
        limit: this.limiteMostradoItemsMes,
        page:  this.paginaActualMes,
      })
      .then(response=>(
        this.informeAcumuladoItemMes = response.data.response.listaitemsMes.data,
        this.desdeMes = response.data.response.listaitemsMes.from,
        this.hastaMes = response.data.response.listaitemsMes.to,
        this.totalMes = response.data.response.listaitemsMes.total

      ))
      .catch(error=>(
        console.log('ERROR',error)
      ))
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .cabecera{
    background-color: yellow;
  }
  .colorTituloProductos{
    text-align: center;
    padding-left: 1%;
    border-radius: 8px;
    background-color:yellow;
    margin-bottom: 2%;
  }
</style>
